import { useBrand } from "hooks/useBrand";
import React, { type ReactNode } from "react";
import { useTranslation } from "react-i18next";

import styles from "./AccountsContainer.module.css";

type AccountsContainerProps = {
	children: ReactNode;
};

const AccountsContainer = ({ children }: AccountsContainerProps) => {
	const { t } = useTranslation("accountsPage");
	const brand = useBrand();

	return (
		<div className={styles.container}>
			<section aria-label={t("container.storyLabel", brand)} className={styles.storyPanel}>
				<img
					alt={t("container.storyImageAlt", brand)}
					className={styles.storyImage}
					src={`${process.env.PUBLIC_URL}/assets/images/left-banner.png`}
				/>
			</section>
			<section aria-label={t("container.formLabel")} className={styles.formPanel}>
				<div className={styles.formWrap}>{children}</div>
			</section>
		</div>
	);
};

export default AccountsContainer;
